/**
 * [CRO] Portability scrubber
 *
 * Catches links pointing to collections, products, or pages that don't exist
 * in this store. When a user clicks one, instead of navigating to a 404, the
 * script intercepts and either:
 *   (a) silently swaps the href to a safe fallback (default: "/"), OR
 *   (b) prevents the navigation entirely if data-cro-block-404 is set on the link.
 *
 * Detection is best-effort: it issues a fetch() HEAD pre-flight only for links
 * the user is about to follow (mousedown/touchstart), so there's no full-page
 * scan cost.
 *
 * Useful when porting a theme from store A to store B where some configured
 * collection/product/page handles don't exist on the new store yet.
 *
 * Auto-disabled in Shopify theme editor (so merchants see the real broken
 * links and can fix them).
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return; // skip in editor

  const SAFE_FALLBACK = '/';
  const CHECKED = new Map();

  function isInternalNavLink(a) {
    if (!a || !a.href) return false;
    const url = new URL(a.href, location.origin);
    if (url.origin !== location.origin) return false;
    return /^\/(collections|products|pages)\//.test(url.pathname);
  }

  async function checkExists(url) {
    if (CHECKED.has(url)) return CHECKED.get(url);
    try {
      const res = await fetch(url, { method: 'HEAD', cache: 'no-cache' });
      const ok = res.ok && res.status !== 404;
      CHECKED.set(url, ok);
      return ok;
    } catch (e) {
      CHECKED.set(url, true); // fail open
      return true;
    }
  }

  async function handlePreNavigation(e) {
    const a = e.target.closest('a');
    if (!isInternalNavLink(a)) return;
    const targetUrl = a.href;
    const exists = await checkExists(targetUrl);
    if (exists) return;
    // Swap href so the upcoming click navigates to the fallback
    a.dataset.croOriginalHref = a.href;
    a.href = SAFE_FALLBACK;
    console.warn('[CRO portability] Swapped broken link to fallback:', targetUrl);
  }

  document.addEventListener('mousedown', handlePreNavigation, true);
  document.addEventListener('touchstart', handlePreNavigation, true);
})();
